<template>
  <div class="serial-settings-view">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>Configuración Serial</h1>
          <p>Gestión de configuraciones seriales del sistema</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="serialSettingsList"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Lista de Configuraciones Seriales</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="refreshData">
                  <v-icon left>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
                <v-btn color="success" class="ml-2" @click="addItem">
                  <v-icon left>mdi-plus</v-icon>
                  Agregar Configuración
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.port="{ item }">
              <v-chip color="blue" variant="outlined" small>
                {{ item.port }}
              </v-chip>
            </template>
            <template v-slot:item.baudRate="{ item }">
              <v-chip color="green" variant="outlined" small>
                {{ item.baudRate }}
              </v-chip>
            </template>
            <template v-slot:item.parity="{ item }">
              <v-chip color="purple" variant="outlined" small>
                {{ item.parity }}
              </v-chip>
            </template>
            <template v-slot:item.dataBits="{ item }">
              <span class="font-weight-medium">{{ item.dataBits }}</span>
            </template>
            <template v-slot:item.stopBits="{ item }">
              <span class="font-weight-medium">{{ item.stopBits }}</span>
            </template>
            <template v-slot:item.timeoutMs="{ item }">
              <span class="font-weight-medium">{{ item.timeoutMs }} ms</span>
            </template>
            <template v-slot:item.delimiter="{ item }">
              <v-chip color="orange" variant="outlined" small>
                {{ getDisplayDelimiter(item.delimiter) }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useSerialSettingsStore } from './store'
import { SerialSettings } from './models/serialSettings'

const serialSettingsStore = useSerialSettingsStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Puerto', key: 'port' },
  { title: 'Baud Rate', key: 'baudRate' },
  { title: 'Bits de Datos', key: 'dataBits' },
  { title: 'Bits de Parada', key: 'stopBits' },
  { title: 'Paridad', key: 'parity' },
  { title: 'Timeout', key: 'timeoutMs' },
  { title: 'Delimitador', key: 'delimiter' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const serialSettingsList = computed(() => serialSettingsStore.serialSettings)

const getDisplayDelimiter = (delimiter: string) => {
  // Función para mostrar delimitadores especiales de forma legible
  switch (delimiter) {
    case '\n':
      return '\\n'
    case '\r':
      return '\\r'
    case '\r\n':
      return '\\r\\n'
    case '\t':
      return '\\t'
    case ' ':
      return 'SPACE'
    default:
      return delimiter || 'Sin delimitador'
  }
}

const refreshData = async () => {
  loading.value = true
  try {
    await serialSettingsStore.getSerialSettings()
  } finally {
    loading.value = false
  }
}

const addItem = () => {
  // Implementar lógica para agregar configuración serial
  console.log('Add new serial settings')
}

const editItem = (item: SerialSettings) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: SerialSettings) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})
</script>

<style scoped>
.serial-settings-view {
  height: 100%;
}
</style>
